var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import * as types from "../utils/types";

import { ADDITIONAL_PROPERTY_FLAG } from "../utils";
import { ButtonRemove } from "../buttons/";

import SchemaLayout from "./SchemaLayout";
import SchemaFieldset from "./SchemaFieldset";

import { getField, getFieldset, isSelect, getUiOptions,
//    isFilesArray,
deepEquals, getSchemaType } from "../utils/";

import UnsupportedField from "./UnsupportedField";

var REQUIRED_FIELD_SYMBOL = "*";

var COMPONENT_TYPES = {
    array: "ArrayField",
    boolean: "BooleanField",
    integer: "NumberField",
    number: "NumberField",
    object: "ObjectField",
    string: "StringField"
};

function getFieldComponent(schema, uiSchema, uiOptions, idSchema, fields) {}

var SchemaField = (_temp2 = _class = function (_React$Component) {
    _inherits(SchemaField, _React$Component);

    function SchemaField() {
        var _temp, _this, _ret;

        _classCallCheck(this, SchemaField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getLanguage = function () {
            var formContext = _this.props.registry.formContext;


            if (formContext.language) {
                return formContext.language;
            }

            return "en";
        }, _this.getFieldComponent = function (props) {
            var schema = props.schema,
                uiSchema = props.uiSchema,
                uiOptions = props.uiOptions,
                idSchema = props.idSchema,
                registry = props.registry;
            var fields = registry.fields;


            var field = uiOptions["field"];

            if (typeof field === "function") {
                return field;
            }

            if (typeof field === "string" && field in fields) {
                return fields[field];
            }

            var componentName = COMPONENT_TYPES[getSchemaType(schema)];

            // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't

            if (!componentName && (schema.anyOf || schema.oneOf)) {
                return function () {
                    return null;
                };
            }

            return componentName in fields ? fields[componentName] : function () {
                return React.createElement(UnsupportedField, {
                    schema: schema,
                    idSchema: idSchema,
                    reason: "Unknown field type " + schema.type
                });
            };
        }, _this.renderField = function (props) {
            var schema = props.schema,
                uiSchema = props.uiSchema,
                registry = props.registry;


            var FieldComponent = _this.getFieldComponent(props);

            var _AnyOfField = registry.fields.AnyOfField;
            var _OneOfField = registry.fields.OneOfField;

            return React.createElement(
                React.Fragment,
                null,
                React.createElement(FieldComponent, props),
                schema.anyOf && !isSelect(schema) && React.createElement(_AnyOfField, {
                    disabled: props.disabled,
                    errorSchema: props.errorSchema,
                    formData: props.formData,
                    idPrefix: props.idPrefix,
                    idSchema: props.idSchema,
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onFocus: props.onFocus,
                    options: schema.anyOf,
                    baseType: schema.type,
                    registry: registry,
                    safeRenderCompletion: props.safeRenderCompletion,
                    uiSchema: uiSchema
                }),
                schema.oneOf && !isSelect(schema) && React.createElement(_OneOfField, {
                    disabled: props.disabled,
                    errorSchema: props.errorSchema,
                    formData: props.formData,
                    idPrefix: props.idPrefix,
                    idSchema: props.idSchema,
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onFocus: props.onFocus,
                    options: schema.oneOf,
                    baseType: schema.type,
                    registry: registry,
                    safeRenderCompletion: props.safeRenderCompletion,
                    uiSchema: uiSchema
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    SchemaField.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // if schemas are equal idSchemas will be equal as well,
        // so it is not necessary to compare
        return !deepEquals(_extends({}, this.props, { idSchema: undefined }), _extends({}, nextProps, { idSchema: undefined }));
    };

    SchemaField.prototype.render = function render() {
        // get field props
        var field = getField(this.props);

        // fieldset
        var fieldset = getFieldset(field);

        if (fieldset) {
            return React.createElement(
                SchemaLayout,
                fieldset,
                React.createElement(SchemaFieldset, fieldset)
            );
        }

        // array field, handle layout in array field

        if (field.schema.type === "array") {
            return this.renderField(field);
        }

        // single field

        return React.createElement(
            SchemaLayout,
            field,
            this.renderField(field)
        );
    };

    return SchemaField;
}(React.Component), _class.defaultProps = {
    uiSchema: {},
    idSchema: {},
    errorSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
}, _temp2);
SchemaField.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    idSchema: PropTypes.object,
    formData: PropTypes.any,
    errorSchema: PropTypes.object,
    registry: types.registry.isRequired
} : {};


export default SchemaField;